import { Spinner, SpinnerSize, Stack, Text } from "@fluentui/react";
import { useEffect, useState } from "react";

import styles from "./LoadingScreen.module.css";

interface LoadingScreenProps {
    message?: string;
    showTimeoutWarning?: boolean;
    onRetry?: () => void;
}

export const LoadingScreen = ({ message = "Loading...", showTimeoutWarning = false, onRetry }: LoadingScreenProps) => {
    const [showWarning, setShowWarning] = useState(false);

    useEffect(() => {
        // Show timeout warning after 5 seconds
        const timer = setTimeout(() => {
            setShowWarning(true);
        }, 5000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div className={styles.loadingScreen}>
            <Stack horizontalAlign="center" verticalAlign="center" tokens={{ childrenGap: 20 }}>
                <Spinner size={SpinnerSize.large} label={message} />
                
                {(showTimeoutWarning && showWarning) && (
                    <Stack tokens={{ childrenGap: 10 }} horizontalAlign="center">
                        <Text variant="medium" style={{ color: "#d13438" }}>
                            This is taking longer than expected...
                        </Text>
                        {onRetry && (
                            <button 
                                onClick={onRetry}
                                style={{
                                    padding: "8px 16px",
                                    background: "#0078d4",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    fontSize: "14px"
                                }}
                            >
                                Retry
                            </button>
                        )}
                    </Stack>
                )}
            </Stack>
        </div>
    );
};

